export enum DialogType {
  CONFIRM = 'confirm'
}
